<template>
  <div class="boxall">
    <div class="title">产业概况</div>
    <div class="boxnav">
      <div class="content">
        <ul class="details">
          <li class="left">
            <!-- 交易额 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/money.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">4.17</span>
                  <span class="unit">亿元</span>
                </div>
                <div class="item-label">小龙虾交易额</div>
              </div>
            </div>

            <!-- 产量 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/shrimp.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">50</span>
                  <span class="unit">亿尾</span>
                </div>
                <div class="item-label">小龙虾苗种年生成量</div>
              </div>
            </div>

            <!-- 基地数量 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/base.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">922</span>
                  <span class="unit">家</span>
                </div>
                <div class="item-label">基地数量</div>
              </div>
            </div>
          </li>

          <li class="right">
            <!-- 小龙虾产量 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/production.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">5.88</span>
                  <span class="unit">万吨</span>
                </div>
                <div class="item-label">小龙虾产量</div>
              </div>
            </div>

            <!-- 养殖面积 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/area.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">36.7</span>
                  <span class="unit">万亩</span>
                </div>
                <div class="item-label">稻虾共作养殖面积</div>
              </div>
            </div>

            <!-- 集货点 -->
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/industry/store.png" alt="icon" />
              </div>
              <div class="item-info">
                <div class="item-value">
                  <span class="num">24</span>
                  <span class="unit">个</span>
                </div>
                <div class="item-label">村级集货点</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustryOverview'
}
</script>

<style scoped>
.content {
  height: 100%;
}

.content > ul {
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.left,
.right {
  flex: 0 0 50%;
  height: 100%;
  display: flex;
  flex-direction: column; /* 纵向排列 3 个框 */
  gap: 5px; /* 上下三行之间的间距 */
  padding: 0 5px;
  box-sizing: border-box;
}

.details > li > div {
  flex: 1; /* 三个框平均分配列高度 */
  width: 100%;
  border-radius: 6px;
  border: 1px solid rgb(5 175 211 / 91%);
}

li > div.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
  padding: 0 2px;
  box-sizing: border-box;
}

.item-icon {
  height: 40px;
  width: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-left: 16px;
  border-radius: 50%;
  border: 2.4px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 16px rgba(0, 191, 255, 0.4), inset 0 0 70px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
}

.item-icon img {
  width: 20px;
  height: 20px;
}

/* 右侧文字区域 — 垂直居中 */
.item-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 4px;
}

/* 第一行：数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.num {
  font-size: 28px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
}

.unit {
  font-size: 16px;
  color: #7ecfea;
}

/* 第二行：描述 */
.item-label {
  font-size: 14px;
  color: #8fb8c8;
  display: flex;
}
</style>
